var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoFlecha(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23435",
    "data-name": "Grupo 23435",
    transform: "translate(-349.946 -236.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14752",
    "data-name": "Grupo 14752",
    transform: "translate(349.946 236.946)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(20 0) rotate(90)",
    fill: "#0099b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66317",
    "data-name": "Trazado 66317",
    d: "M535.417,428.264a.9.9,0,0,0-1.272,0h0l-2.75,2.749a.3.3,0,0,1-.424,0l-2.749-2.749a.9.9,0,1,0-1.272,1.272l2.75,2.75a2.1,2.1,0,0,0,2.968,0h0l2.75-2.75A.909.909,0,0,0,535.417,428.264Z",
    transform: "translate(-521.181 -419.45)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFlecha);
export default __webpack_public_path__ + "static/media/Icono-Flecha.ebd40efb3286a3800624c05ee681e3f5.svg";
export { ForwardRef as ReactComponent };